/**
 * Badge Atom Component
 * Reusable badge component for displaying info tags
 */

import { cn } from '@/lib/utils'
import { type LucideIcon } from 'lucide-react'

interface BadgeProps {
	icon?: LucideIcon
	label: string
	variant?: 'default' | 'primary' | 'secondary'
	className?: string
}

export function Badge({
	icon: Icon,
	label,
	variant = 'default',
	className,
}: BadgeProps) {
	const variantStyles = {
		default: 'bg-gray-100 text-gray-900',
		primary: 'bg-[#09194D] text-white',
		secondary: 'bg-[#CDFF00] text-[#09194D]',
	}

	return (
		<div
			className={cn(
				'flex items-center gap-1.5 px-3 py-1.5 rounded-md font-["Bricolage_Grotesque"] text-xs font-bold',
				variantStyles[variant],
				className
			)}
		>
			{Icon && <Icon className='w-4 h-4' />}
			<span>{label}</span>
		</div>
	)
}
